import React from 'react';
import classname from 'classnames';
import { bool, func } from 'prop-types';
import { noop } from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './style.css';

class SwitchButton extends React.Component {
  static propTypes = {
    onChange: func,
    checked: bool,
  };

  static defaultProps = {
    onChange: noop,
    checked: false,
  };

  render() {
    const { onChange, checked } = this.props;
    return (
      <label className={s.switch} htmlFor="input-switch">
        <input
          type="checkbox"
          id="input-switch"
          onChange={onChange}
          checked={checked}
        />
        <span className={classname(s.slider, s.round)} />
      </label>
    );
  }
}

export default withStyles(s)(SwitchButton);
